<template>
    <div class="order-detail">

        <!-- Top meta row -->
        <div class="order-meta d-flex flex-wrap align-items-center mb-3 gap-2">
            <div class="mr-4">
                <small class="text-uppercase text-muted font-weight-bold">Email</small>
                <div>{{ order.email }}</div>
            </div>
            <div v-if="order.purchase_order" class="mr-4">
                <small class="text-uppercase text-muted font-weight-bold">Purchase Order</small>
                <div>{{ order.purchase_order }}</div>
            </div>
        </div>

        <!-- Items table -->
        <div class="table-responsive mb-4">
            <table class="table table-sm table-hover items-table mb-0">
                <thead>
                    <tr>
                        <th>SKU</th>
                        <th>Name</th>
                        <th class="text-right">Unit Price</th>
                        <th class="text-right">Qty</th>
                        <th class="text-right">Subtotal</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in order.items" :key="index">
                        <td><code class="text-secondary">{{ item.sku }}</code></td>
                        <td>{{ item.name }}</td>
                        <td class="text-right">{{ item.unit_price | currency }}</td>
                        <td class="text-right">{{ item.quantity }}</td>
                        <td class="text-right font-weight-semibold">{{ item.subtotal | currency }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Shipping + Tracking + Totals -->
        <div class="d-flex flex-wrap justify-content-between">

            <!-- Shipping address -->
            <div class="detail-block mr-4 mb-3">
                <div class="detail-label">Ship To</div>
                <div class="font-weight-semibold">{{ order.shippingname }}</div>
                <div class="text-muted">{{ order.shippingaddress }}</div>
                <div class="text-muted">{{ order.shippingcity }}, {{ order.shippingstate }} {{ order.shippingzip }}</div>
            </div>
            <div class="detail-block mr-4 mb-3">
                <div class="detail-label">Bill To</div>
                <div class="font-weight-semibold">{{ order.billing.name }}</div>
                <div class="text-muted">{{ order.billing.address }}</div>
                <div class="text-muted">{{ order.billing.city }}, {{ order.billing.state }} {{ order.billing.zip }}</div>
            </div>

            <!-- Tracking -->
            <div v-if="order.shipping_status && order.shipping_status.carrier" class="detail-block mr-4 mb-3">
                <div class="detail-label">Tracking</div>
                <div class="font-weight-semibold">{{ order.shipping_status.carrier }}</div>
                <div class="text-muted font-monospace">{{ order.shipping_status.tracking_number }}</div>
                <div v-if="order.shipping_status.delivery_status">
                    <b-badge :variant="deliveryVariant(order.shipping_status.delivery_status)" class="mt-1">
                        {{ order.shipping_status.delivery_status }}
                    </b-badge>
                    <span v-if="order.shipping_status.delivery_date" class="ml-1 text-muted small">
                        — {{ order.shipping_status.delivery_date }}
                    </span>
                </div>
            </div>

            <!-- Totals -->
            <div class="detail-block totals-block mb-3 ml-auto text-right">
                <div class="d-flex justify-content-between mb-1">
                    <span class="text-muted mr-4">Subtotal</span>
                    <span>{{ order.subtotal | currency }}</span>
                </div>
                <div class="d-flex justify-content-between mb-1">
                    <span class="text-muted mr-4">Shipping</span>
                    <span>{{ order.shipping | currency }}</span>
                </div>
                <div class="d-flex justify-content-between total-row pt-1">
                    <span class="font-weight-bold mr-4">Total</span>
                    <span class="font-weight-bold">{{ order.total | currency }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Order",
    props: ['order'],
    methods: {
        deliveryVariant(status) {
            const s = (status || '').toLowerCase();
            if (s.includes('delivered'))  return 'success';
            if (s.includes('transit') || s.includes('shipped')) return 'info';
            if (s.includes('exception') || s.includes('failed')) return 'danger';
            return 'warning';
        },
    },
    created() {
        console.log(this.order);
    },
};
</script>

<style scoped lang="scss">
.order-detail {
    padding: 1.25rem 1.5rem 1rem;
    font-size: .875rem;
}

.order-meta {
    padding-bottom: .75rem;
    border-bottom: 1px solid #e9ecef;
}

.items-table {
    thead th {
        background: #f1f3f8;
        font-size: .75rem;
        text-transform: uppercase;
        letter-spacing: .04em;
        color: #6c757d;
        border-top: none;
        border-bottom: 2px solid #dee2e6;
    }
    tbody tr:last-child td { border-bottom: none; }
}

.detail-block {
    min-width: 160px;
}

.detail-label {
    font-size: .7rem;
    text-transform: uppercase;
    letter-spacing: .05em;
    color: #adb5bd;
    font-weight: 700;
    margin-bottom: .25rem;
}

.totals-block {
    min-width: 200px;
    padding-top: .25rem;
}

.total-row {
    border-top: 1px solid #dee2e6;
}

.font-weight-semibold { font-weight: 600; }
.font-monospace { font-family: 'SFMono-Regular', Consolas, monospace; }
</style>